import { render } from "./HomeHistory.vue?vue&type=template&id=2e6d8272&scoped=true"
import script from "./HomeHistory.vue?vue&type=script&lang=js"
export * from "./HomeHistory.vue?vue&type=script&lang=js"

import "./HomeHistory.vue?vue&type=style&index=0&id=2e6d8272&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2e6d8272"

export default script